export const AUTH_ROUTE_PATHS = {
  AUTH_CALLBACK: "/auth/callback",
  AUTH_CHECK: "/auth/check",
  LOGIN: "/login",
  LOGOUT: "/logout",
  LOGOUT_CALLBACK: "/logout/callback",
};
